module.exports = __webpack_public_path__ + "static/brushStrokeSmallFlipped50-f9dc347850e11f369271e0541be741af.png";